import type { AxiosInstance } from "axios";
import type { FwaasOverview } from "./overview.types";

/**
 * Dev-only: a case of `overviewFixtures` ("ha-pair", "standalone-busy", …) served in
 * place of the backend. Build-time-inlined as `''` in production, so the branch and its
 * dynamic import are dropped (the `REACT_APP_MOCK_BGP` precedent).
 */
const MOCK_CASE = process.env.REACT_APP_MOCK_FWAAS_OVERVIEW;

/**
 * `GET /kontroledge/fwaas/:id/overview?tenantId=` (CTX-1091), unwrapped from the
 * `{ success, message, data }` envelope. Throws when the envelope is not what we expect,
 * so a malformed answer never reaches the cards as `undefined`.
 */
export async function fetchFwaasOverview(
    api: AxiosInstance,
    tenantId: number,
    fwaasId: string
): Promise<FwaasOverview> {
    if (MOCK_CASE) {
        const { OVERVIEW_FIXTURES, isOverviewFixtureCase } = await import("./overviewFixtures");
        if (isOverviewFixtureCase(MOCK_CASE)) return OVERVIEW_FIXTURES[MOCK_CASE];
    }
    const response = await api.get(`/kontroledge/fwaas/${encodeURIComponent(fwaasId)}/overview`, {
        params: { tenantId },
    });
    const body = response.data as { success?: boolean; message?: string; data?: FwaasOverview };
    if (!body?.success || !body.data) {
        throw new Error(body?.message ?? "Failed to load the Virtual Firewall overview");
    }
    return body.data;
}
